export enum ProviderLifecycleStatus {
	ACTIVE = 'active',
	PLANNED = 'planned',
	POC = 'poc',
	TERMINATED = 'terminated',
}

export enum ProviderDataClassification {
	PII = 'pii',
	PHI = 'phi',
	CUSTOMER_DATA = 'customer_data',
	BUSINESS_DATA = 'business_data',
	FINANCIAL_DATA = 'financial_data',
	EMPLOYEE_PERSONAL_DATA = 'employee_personal_data',
	MARKETING_DATA = 'marketing_data',
	PAYMENT = 'payment',
	OTHER = 'other',
}

export enum BusinessImpact {
	CRITICAL = 'critical',
	NON_CRITICAL = 'non_critical',
}

export enum RiskLevel {
	HIGH = 'high',
	MEDIUM = 'medium',
	LOW = 'low',
}
